// extracted by mini-css-extract-plugin
module.exports = {"dashboardWrapper":"Dashboard_dashboardWrapper__D9hM3","dashboardBody":"Dashboard_dashboardBody__1aEhe","dashboardTableTypeCol":"Dashboard_dashboardTableTypeCol__3G2Ax"};